module.exports = __webpack_public_path__ + "img/input-password-icon.326625a6.svg";